export const PREPARE_INVOICE_PERMISSIONS = ['SL_SALES_INVOICE_PREPARE', 'SL_SALES_INVOICE_ISSUE'];
const VAT_PERMISSIONS = new Set(['SL_SALES_INVOICE_ISSUE', 'SL_SALES_INVOICE_SEND_TAX',
  'SL_SALES_INVOICE_ADJUST', 'SL_SALES_INVOICE_CANCEL']);
export const requiresAssignedInvoicePermission = aliases => (Array.isArray(aliases) ? aliases : [aliases])
  .some(alias => VAT_PERMISSIONS.has(String(alias || '').trim().toUpperCase()));
